import certificates from './certificates'
import users from './users'
import settings from './settings'
import importCertificates from './importCertificates'

export default (t) => {
    return [
        {
            route: 'certificates',
            label: t('navigation.certificates_section'),
            icon: 'view-dashboard-outline',
            sidebarItemName: 'certificates',
            isStandaloneItem: true,
            children: certificates(t)
        },
        {
            route: 'import',
            label: t('navigation.import_section'),
            icon: 'import',
            sidebarItemName: 'importCertificates',
            isStandaloneItem: true,
            children: importCertificates(t),
            permissions: ['certificate.import']
        },
        {
            route: '',
            label: t('navigation.user_section'),
            icon: 'shield-account-outline',
            sidebarItemName: 'users',
            isStandaloneItem: false,
            children: users(t),
            permissions: ['user.admin']
        },
        {
            route: '',
            label: t('navigation.settings_section'),
            icon: 'cog-outline',
            sidebarItemName: 'settings',
            isStandaloneItem: false,
            children: settings(t),
            permissions: [
                'settings.certificate',
                'settings.allowed_ips',
                'settings.one-hop',
                'settings.hosting-platforms',
                'settings.certificate-providers'
            ]
        }
    ]
}
